import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import { fileupload, leftArrow } from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../zustand/useStore";
import { file_post, get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../Components/Loader";

const AddTransport = () => {
  // const tabs = ["Transport Details", "Vehicles", "Drivers", "Bookings"];
  const [step, setStep] = useState(1);
  const navigation = useNavigate();
  const fileRefs = useRef({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const { setData, data, clearData } = useStore();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [transDat, setTransportDat] = useState(null);
 

  const [formData, setFormData] = useState({
    transport_name: "",
    Owner_name: "",
    Mobile_number: "",
    email_id: "",
    property_tax: "",
    rental_agreement: "",
    gst_certificate: "",
    pancard: "",
    panproperietor: "",
    companyregisteration: "",
    msmeregisteration: "",
    laborlicence: "",
    bankpassbook: "",
    cancelledcheque: "",
    bankaccountname: "",
    ifsc: "",
    accountno: "",
    branch: "",
    companydeclarations: "",
    ndaagreement: "",
    agreementcopy: "",
    authorizationletter: "",
  });



  // ----------- FORM FIELDS -----------
  const fields = [
    {
      type: 1,
      title: "Add Transport Details",
      subtitle: "Contact & Address Proof",
      data: [
        {
          id: 1,
          name: "transport_name",
          label: "Transport Name",
          placeholder: "Enter Transport Name",
          fileupload: false,
          value: formData?.transport_name,
        },
        {
          id: 2,
          name: "Owner_name",
          label: "Owner Name",
          placeholder: "Enter Owner Name",
          fileupload: false,
          value: formData?.Owner_name,
        },
        {
          id: 3,
          name: "Mobile_number",
          label: "Mobile number",
          placeholder: "Enter Mobile Number",
          fileupload: false,
          value: formData?.Mobile_number,
        },
        {
          id: 4,
          name: "email_id",
          label: "Email ID",
          placeholder: "Enter your Email",
          fileupload: false,
          value: formData?.email_id,
        },
        {
          id: 5,
          name: "property_tax",
          label: "Property Tax",
          placeholder: "Property tax PDF",
          fileupload: true,
          value: formData?.property_tax,
        },
        {
          id: 6,
          name: "rental_agreement",
          label: "Rental Agreement",
          placeholder: "Rental Agreement.PDF",
          fileupload: true,
          value: formData?.rental_agreement,
        },
      ],
    },
    {
      type: 2,
      title: "Add Transport Details",
      subtitle: "Business & identity Proofs",
      data: [
        {
          id: 1,
          name: "gst_certificate",
          label: "GST Certificate",
          placeholder: "Upload GST Certificate (PDF)",
          fileupload: true,
          value: formData?.gst_certificate,
        },
        {
          id: 2,
          name: "pancard",
          label: "PAN Card (Company)",
          placeholder: "Upload Company PAN Card (PDF)",
          fileupload: true,
          value: formData?.pancard,
        },
        {
          id: 3,
          name: "panproperietor",
          label: "PAN Card (Proprietor)",
          placeholder: "Upload Proprietor PAN Card (PDF)",
          fileupload: true,
          value: formData?.panproperietor,
        },
        {
          id: 4,
          name: "companyregisteration",
          label: "Company Registration Documents",
          placeholder: "Upload Company Registration Certificate (PDF)",
          fileupload: true,
          value: formData?.companyregisteration,
        },
        {
          id: 5,
          name: "msmeregisteration",
          label: "MSME Registration",
          placeholder: "Upload MSME Registration Certificate (PDF)",
          fileupload: true,
          value: formData?.msmeregisteration,
        },
        {
          id: 6,
          name: "laborlicence",
          label: "Labor License",
          placeholder: "Upload Labor License Certificate (PDF)",
          fileupload: true,
          value: formData?.laborlicence,
        },
      ],
    },
    {
      type: 3,
      title: "Add Transport Details",
      subtitle: "Banking & Financial Documents",
      data: [
        {
          id: 1,
          name: "bankpassbook",
          label: "Bank Passbook",
          placeholder: "Bank Passbook.PDF",
          fileupload: true,
          value: formData?.bankpassbook,
        },
        {
          id: 2,
          name: "cancelledcheque",
          label: "Cancelled Cheque",
          placeholder: "Cancelled Cheque.PDF",
          fileupload: true,
          value: formData?.cancelledcheque,
        },
        {
          id: 3,
          name: "bankaccountname",
          label: "Bank Account Name",
          placeholder: "Enter Name",
          fileupload: false,
          value: formData?.bankaccountname,
        },
        {
          id: 4,
          name: "ifsc",
          label: "IFSC",
          placeholder: "Enter IFSC Code",
          fileupload: false,
          value: formData?.ifsc,
        },
        {
          id: 5,
          name: "accountno",
          label: "Bank Account No",
          placeholder: "Enter Bank Account NO",
          fileupload: false,
          value: formData?.accountno,
        },
        {
          id: 6,
          name: "branch",
          label: "Branch",
          placeholder: "Enter Branch",
          fileupload: false,
          value: formData?.branch,
        },
      ],
    },
    {
      type: 4,
      title: "Add Transport Details",
      subtitle: "Company Declarations",
      data: [
        {
          id: 1,
          name: "companydeclarations",
          label: "Company Declarations",
          placeholder: "upload companydeclarations.PDF",
          fileupload: true,
          value: formData?.companydeclarations,
        },
        {
          id: 2,
          name: "ndaagreement",
          label: "NDA Agreement.PDF",
          placeholder: "upload ndaagreement.PDF",
          fileupload: true,
          value: formData?.ndaagreement,
        },
        {
          id: 3,
          name: "agreementcopy",
          label: "Agreement/Contract Copy",
          placeholder: "uploadagreementcopy",
          fileupload: true,
          value: formData?.agreementcopy,
        },
        {
          id: 4,
          name: "authorizationletter",
          label: "Authorization Letter",
          placeholder: "upload authorizationletter",
          fileupload: true,
          value: formData?.authorizationletter,
        },
        // { id: 5, label: "Bank Account No", placeholder: "Enter Bank Account NO", fileupload: false },
        // { id: 6, label: "Branch", placeholder: "Enter Branch", fileupload: false },
      ],
    },
  ];

  // ----------- GET CURRENT STEP DATA -----------
  const currentSection = fields.find((item) => item.type === step);

  // ----------- NEXT BUTTON -----------
  const validateField = (item, value) => {
    const inputValue = (value || "").toString().trim();

    if (!inputValue) {
      return `${item.label} is required`;
    }

    if (item.name === "email_id") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        return "Enter a valid email address";
      }
    }

    if (item.name === "Mobile_number") {
      const mobileRegex = /^[0-9]{10}$/;
      if (!mobileRegex.test(inputValue.replace(/\D/g, ""))) {
        return "Enter a valid 10-digit mobile number";
      }
    }

    if (item.name === "ifsc") {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscRegex.test(inputValue.toUpperCase())) {
        return "Enter a valid IFSC code";
      }
    }

    if (item.name === "accountno") {
      const accountRegex = /^[0-9]{9,18}$/;
      if (!accountRegex.test(inputValue)) {
        return "Enter a valid bank account number";
      }
    }

    return "";
  };

  const validateSection = (sectionType) => {
    const section = fields.find((f) => f.type === sectionType);
    if (!section) return true;

    const sectionErrors = {};

    section.data.forEach((item) => {
      const errorMessage = validateField(item, formData[item.name]);
      if (errorMessage) {
        sectionErrors[item.name] = errorMessage;
      }
    });

    setErrors((prev) => {
      const next = { ...prev };
      section.data.forEach((item) => {
        delete next[item.name];
      });
      return { ...next, ...sectionErrors };
    });

    return Object.keys(sectionErrors).length === 0;
  };

  const validateAllSections = () => {
    const allErrors = {};

    fields.forEach((section) => {
      section.data.forEach((item) => {
        const errorMessage = validateField(item, formData[item.name]);
        if (errorMessage) {
          allErrors[item.name] = errorMessage;
        }
      });
    });

    setErrors(allErrors);

    if (Object.keys(allErrors).length > 0) {
      const firstInvalidSection = fields.find((section) =>
        section.data.some((item) => allErrors[item.name]),
      );
      if (firstInvalidSection) {
        setStep(firstInvalidSection.type);
      }
      return false;
    }

    return true;
  };

  const TransPost = async () => {
    const payload = new FormData();
    payload.append("step", String(step));

    const appendField = (key, value) => {
      if (value instanceof File) {
        payload.append(key, value, value.name);
        return;
      }
      payload.append(key, value ?? "");
    };

    if (step === 1) {
      appendField("name", formData?.transport_name);
      appendField("owner_name", formData?.Owner_name);
      appendField("mobile", formData?.Mobile_number);
      appendField("email", formData?.email_id);
      appendField("rental_aggrement", formData?.rental_agreement);
      appendField("property_tax", formData?.property_tax);
    } else if (step === 2) {
      appendField("transport_id", transDat);
      appendField("gst", formData?.gst_certificate);
      appendField("pan_company", formData?.pancard);
      appendField("pan_proprietor", formData?.panproperietor);
      appendField("company_registration", formData?.companyregisteration);
      appendField("msme_registration", formData?.msmeregisteration);
      appendField("labour_licence", formData?.laborlicence);
    } else if (step === 3) {
      appendField("transport_id", transDat);
      appendField("bank_passbook", formData?.bankpassbook);
      appendField("cancelled_cheque", formData?.cancelledcheque);
      appendField("acc_name", formData?.bankaccountname);
      appendField("acc_no", formData?.accountno);
      appendField("ifsc", formData?.ifsc);
      appendField("branch", formData?.branch);
    } else if (step === 4) {
      appendField("transport_id", transDat);
      appendField("company_declaration", formData?.companydeclarations);
      appendField("contract_copy", formData?.agreementcopy);
      appendField("authorization_letter", formData?.authorizationletter);
      appendField("nda_aggrement", formData?.ndaagreement);
    }

    setLoading(true);
    const res = await file_post(URLS.TRANSPORT_ADD, payload);
    console.log("res add trans", res);
    if (res?.status === "success") {
      if (step === 1) {
        setTransportDat(res?.transport_id);
      }
      setLoading(false);
      if (step < fields.length) {
        setStep(step + 1);
      } else {
        setLoading(false);
      }
      if(step === 4) {
        navigation('/transport')
      }
      
    } 
    setLoading(false);
  };

  const handleNext = async () => {
    if (!validateSection(step)) return;

    setData({
      transport_name: formData?.transport_name,
      Owner_name: formData?.Owner_name,
      Mobile_number: formData?.Mobile_number,
      email_id: formData?.email_id,
      property_tax: formData?.property_tax,
      rental_agreement: formData?.rental_agreement,
      gst_certificate: formData?.gst_certificate,
      pancard: formData?.pancard,
      panproperietor: formData?.panproperietor,
      companyregisteration: formData?.companyregisteration,
      msmeregisteration: formData?.msmeregisteration,
      laborlicence: formData?.laborlicence,
      bankpassbook: formData?.bankpassbook,
      cancelledcheque: formData?.cancelledcheque,
      bankaccountname: formData?.bankaccountname,
      ifsc: formData?.ifsc,
      accountno: formData?.accountno,
      branch: formData?.branch,
      companydeclarations: formData?.companydeclarations,
      ndaagreement: formData?.ndaagreement,
      agreementcopy: formData?.agreementcopy,
      authorizationletter: formData?.authorizationletter,
    });

    TransPost();
  };

    const handleSave = () => {
      if (!validateSection(step))
         return;
      TransPost();
    };

  // ----------- BACK BUTTON -----------
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    } else {
      navigation(-1);
    }
  };

  const handleFileChange = (e, id, name) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [id]: file.name, // store file name
      }));
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleInputChange = (e, name) => {
    let { value } = e.target;
    // ✅ Mobile number restriction
    if (name === "Mobile_number") {
      value = value.replace(/\D/g, ""); // allow only numbers
      if (value.length > 10) return; // stop typing after 10 digits
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  return (
    <>
      <Header />

      <div className="transport-container">
        <h2 className="title">Swift way Transports</h2>

        {/* Tabs */}
        {/* <div className="tabs">
                    {tabs.map((tab, index) => (
                        <button key={index} className={`tab-btn ${index === 0 ? "active" : ""}`}>
                            {tab}
                        </button>
                    ))}
                </div> */}

        {/* Section Title */}
        <div className="section">
          <h3 onClick={handleBack} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            {currentSection?.title}
          </h3>
          <h6 onClick={handleBack} className="text-warning mb-3">
           
            {currentSection?.subtitle}
          </h6>

          {/* FORM GRID */}
          <div className="form-grid">
            {currentSection?.data.map((item) => {
              const uniqueId = `${currentSection.type}-${item.id}`;

              return (
                <div className="form-groupz" key={uniqueId}>
                  <label>{item.label}</label>

                  {item.fileupload ? (
                    <div
                      className="upload-boxz"
                      onClick={() => fileRefs.current[uniqueId]?.click()}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="text"
                        className="pointer"
                        placeholder={item.placeholder}
                        value={
                          uploadedFiles[uniqueId] || item.value?.name || ""
                        }
                        readOnly
                      />
                      <input
                        type="file"
                        // id={`file-${item.id}`}
                        ref={(el) => (fileRefs.current[uniqueId] = el)}
                        onChange={(e) =>
                          handleFileChange(e, uniqueId, item.name)
                        }
                        style={{ display: "none" }}
                      />
                      <label htmlFor={`file-${item.id}`} className="upload-btn">
                        <img src={fileupload} alt="" className="uploadIconn " />
                      </label>
                    </div>
                  ) : (
                    <input
                      type="text"
                      placeholder={item.placeholder}
                      className="fileinput"
                      value={item.value}
                      onChange={(e) => handleInputChange(e, item.name)}
                    />
                  )}
                  {errors[item.name] ? (
                    <p className="text-danger mt-1 mb-0">{errors[item.name]}</p>
                  ) : null}
                </div>
              );
            })}
          </div>

          {/* ACTION BUTTONS */}
          <div className="actions">
            {/* {step === 4 &&
            <button className="save-btn" onClick={handleSave}>
              Save
            </button>
} */}

{step === 4 && (
  <button className="save-btn" onClick={handleSave} disabled={loading}>
    {loading ? (
      <>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          style={{ color: "white", padding: 8 }}
        ></span>
      </>
    ) : (
      "Save"
    )}
  </button>
)}
            {step < fields.length && (
              <button onClick={handleNext} className="resolve-btn">
                Next
              </button>
            )}
            {/* {loading && <Loader />} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransport;
